import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { viewDocument } from 'src/app/controls/functions/functions';
import { markFormGroupTouched } from 'src/app/controls/functions/shared-functions';
import { getInvalidFieldsV2, jsonDeepParse, prepareFieldConfigFlagsNew } from 'src/app/functions/shared-functions';
import { ConfirmationComponent } from 'src/app/modules/shared/confirmation/confirmation.component';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';

@Component({
  selector: 'app-driving-license',
  templateUrl: './driving-license.component.html',
  styleUrls: ['./driving-license.component.scss']
})
export class DrivingLicenseComponent implements OnInit {

  master_data: any = {};
  drivingLicenseForm: UntypedFormGroup = new UntypedFormGroup({
    "countryId": new UntypedFormControl(null),
    "issueDate": new UntypedFormControl(null),
    "expiryDate": new UntypedFormControl(null),
    "licenseType": new UntypedFormControl(1),   // 1- heavy, 2- light
    "vehicleName": new UntypedFormControl(null),
    "attachments": new UntypedFormControl(null),
  })
  exp_list = []
  validUploaded: boolean = true;
  all_rights: any = {};
  field_config_access: any = {};
  id = 0;
  jobseeker = {
    selected_jobtitle: [],
    jobTitleList: [],
    jobTitleMasters: {
      take: 100,
      skip: 0,
      totalcount: 0
    },
  }
  countryList = []
  selected_designation;
  today = new Date()
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialog_ref: MatDialogRef<DrivingLicenseComponent>,
    private dialog: MatDialog,
    private notification: NotificationService,
    private translate: TranslateService,
    // private resume_srv: ResumeService
  ) { }

  ngOnInit(): void {
    if (this.data) {
      console.log(this.data)
      this.countryList = this.data.country_list
      if (this.data.id) {
        this.id = this.data.id
      }
      this.master_data = this.data.master_data;
      this.exp_list = jsonDeepParse(this.data.list) || [];
      console.log(this.master_data)
      this.all_rights = this.data.all_rights;
      if (this.all_rights) {
        this.field_config_access = prepareFieldConfigFlagsNew(this.all_rights, this.drivingLicenseForm, null, 'RES-DL')
      }
    }


  }
  close() {
    this.dialog_ref.close()
  }
  save() {
    if (this.validUploaded) {
      this.dialog_ref.close(this.exp_list)
    }
    else {
      this.notification.error('ERROR.please_wait_while_attachments_being_uploaded', 'Close', 5000)
    }
  }

  addExperience() {
    if (this.drivingLicenseForm.valid && this.validUploaded) {
      if (this.exp_list && this.exp_list.length) {
        this.exp_list.push(this.drivingLicenseForm.value);
      }
      else {
        this.exp_list = [this.drivingLicenseForm.value];
      }
      this.drivingLicenseForm.reset();
    }
    else {
      if (!this.validUploaded) {
        this.notification.error('ERROR.please_wait_while_attachments_being_uploaded', 'Close', 5000)
        return;
      }
      else {
        markFormGroupTouched(this.drivingLicenseForm)
        getInvalidFieldsV2(this.drivingLicenseForm, this.translate, this.notification, 'RESUME.', null, this.field_config_access, 'RES-DL')
      }
    }

  }

  editExperience(index) {
    this.drivingLicenseForm.patchValue(this.exp_list[index]);
    this.exp_list.splice(index, 1);
    
  }
  deleteExperience(index) {
    this.dialog
      .open(ConfirmationComponent, {
        width: "480px",
        height: "auto",
        panelClass: "icr-dialog",
        data: {
          title: "CONFIRMATION.confirmation",
          message: "CONFIRMATION.are_you_sure_to_delete",
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.exp_list.splice(index, 1);
        }
      });
  }
  uploadedStatus(ev) {
    this.validUploaded = ev
  }
  viewAttachments(list) {
    viewDocument(list, list[0], this.dialog)
  }
  jobTitleChanged(ev) {
    this.selected_designation = ev
  }
  // loadJobtitleList(ev) { //load job title based on search keywords
  //   if (ev) {
  //     this.resume_srv.getRequirementList({
  //       'search': ev.search
  //     }).subscribe(res => {
  //       if (res && res['data']) {
  //         if (res['data'].list && res['data'].list.length) {
  //           if (this.jobseeker.selected_jobtitle && this.jobseeker.selected_jobtitle.length) {
  //             this.jobseeker.jobTitleList = [...res['data'].list, ...this.jobseeker.selected_jobtitle];
  //             this.jobseeker.jobTitleList = removeDuplicate(this.jobseeker.jobTitleList, 'id')
  //           }
  //           else {
  //             this.jobseeker.jobTitleList = res['data'].list;

  //           }
  //         }
  //         else {
  //           this.jobseeker.jobTitleList = [];
  //         }

  //       }
  //     })
  //   }

  // }
}

